export default {
  image: 'A4_10_2.png',
  pdf: '220922_WA-MIWO_012_A4_10_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-012',
    technicalValues: {
      soundReductionIndex: {
        output: '53,4',
        value: 53.4
      },
      heatTransferCoefficient: {
        output: '0,16',
        value: 0.16
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 90-B',
        value: 'F-90-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 12',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '60 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/180',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-180'
        },
        {
          output: '180 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-180'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'ip-15'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '289',
        value: 289
      }
    }
  }
}
